import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { scheduleData } from '../data';

const ModuleIcon = ({ name, color, size = 40 }) => {
  const iconColor = color || 'currentColor';
  const s = size;
  const icons = {
    dna: (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 15c6-4 14-4 20 0M2 9c6 4 14 4 20 0M9 2v20M15 2v20M9 6h6M9 10h6M9 14h6M9 18h6" />
      </svg>
    ),
    map: (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
        <line x1="8" y1="2" x2="8" y2="18" />
        <line x1="16" y1="6" x2="16" y2="22" />
      </svg>
    ),
    broadcast: (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
    ),
    coffee: (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8h1a4 4 0 0 1 0 8h-1" />
        <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" />
        <line x1="6" y1="1" x2="6" y2="4" />
        <line x1="10" y1="1" x2="10" y2="4" />
        <line x1="14" y1="1" x2="14" y2="4" />
      </svg>
    ),
    viral: (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M8 12h8M12 8v8M9.5 9.5l5 5M14.5 9.5l-5 5" />
      </svg>
    ),
    closure: (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </svg>
    ),
  };
  return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: iconColor }}>{icons[name] || icons.closure}</Box>;
};

const Programa = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          variant="overline"
          color="secondary"
          align="center"
          display="block"
          gutterBottom
        >
          🎙️ Programa de alto impacto
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          align="center"
          gutterBottom
        >
          Agenda
        </Box>
      </Box>
      <Grid container spacing={2}>
        {scheduleData.map((item, i) => (
          <Grid item xs={12} key={i}>
            <Box
              component={Card}
              variant="outlined"
              sx={{
                bgcolor: item.isBreak
                  ? (theme.palette.mode === 'dark' ? 'grey.800' : 'grey.100')
                  : 'transparent',
                transition: 'all .2s ease-in-out',
                '&:hover': item.isBreak ? {} : { transform: 'translateY(-2px)', boxShadow: 2 },
              }}
            >
              <CardContent>
                <Box
                  display="flex"
                  flexDirection={{ xs: 'column', sm: 'row' }}
                  alignItems={{ sm: 'flex-start' }}
                  gap={2}
                >
                  <Box
                    sx={{
                      minWidth: 56,
                      height: 56,
                      borderRadius: 2,
                      bgcolor: item.isBreak ? 'grey.500' : 'primary.main',
                      color: item.isBreak ? 'grey.300' : 'primary.contrastText',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    <ModuleIcon
                      name={item.icon}
                      color={item.isBreak ? undefined : theme.palette.primary.contrastText}
                      size={28}
                    />
                  </Box>
                  <Box flex={1} minWidth={0}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                      {item.title}
                    </Typography>
                    {item.subtitle && (
                      <Typography color="textSecondary" variant="body2" fontStyle="italic" gutterBottom>
                        {item.subtitle}
                      </Typography>
                    )}
                    {item.topics && item.topics.length > 0 && (
                      <Box component="ul" sx={{ m: 0, pl: 2.5, mt: 1 }}>
                        {item.topics.map((topic, j) => (
                          <Typography
                            key={j}
                            component="li"
                            variant="body2"
                            color="text.secondary"
                            sx={{ mb: 0.5 }}
                          >
                            {topic}
                          </Typography>
                        ))}
                      </Box>
                    )}
                  </Box>
                </Box>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Programa;
